import { QUERY_KEYS } from 'constants/constants'
import { usePartnerContext } from '../context'
import { useMutationAndUpdateQuery } from './use-mutation-and-update-query'

export const usePartnerIntegrationDelete = () => {
  const { partner } = usePartnerContext()

  return useMutationAndUpdateQuery({
    queryKey: QUERY_KEYS.partnerIntegrationsByPartner(partner.id),
    mutation: 'deleteIntegration',
    updater: ({ prevData, response }) => {
      return [...prevData].filter(({ id }) => id !== response.id)
    }
  })
}
